import postService from '../services/posts';
import type { AppDispatch } from '../store';
import type { VotePayload } from '../types/common';

const computePointsCount = (upvotedBy: string[], downvotedBy: string[]): number => {
  const pointsCount = upvotedBy.length - downvotedBy.length;
  return pointsCount < 0 ? 0 : pointsCount;
};

/**
 * Build the `toggleUpvote`/`toggleDownvote` thunks for a post list slice.
 *
 * Every post-list reducer (feed, herd page, user page, search) performs the
 * exact same optimistic update; they only differ in the action `type` their
 * reducer listens for. This factory captures that shared logic so each reducer
 * only has to declare its action type.
 */
export const createVoteThunks = (actionType: string) => {
  const dispatchVote = (dispatch: AppDispatch, id: string, upvotedBy: string[], downvotedBy: string[]) => {
    const payload: VotePayload = {
      id,
      data: { upvotedBy, downvotedBy, pointsCount: computePointsCount(upvotedBy, downvotedBy) },
    };
    dispatch({ type: actionType, payload });
  };

  const toggleUpvote = (id: string, upvotedBy: string[], downvotedBy: string[]) => {
    return async (dispatch: AppDispatch) => {
      dispatchVote(dispatch, id, upvotedBy, downvotedBy);
      await postService.upvotePost(id);
    };
  };

  const toggleDownvote = (id: string, downvotedBy: string[], upvotedBy: string[]) => {
    return async (dispatch: AppDispatch) => {
      dispatchVote(dispatch, id, upvotedBy, downvotedBy);
      await postService.downvotePost(id);
    };
  };

  return { toggleUpvote, toggleDownvote };
};
